export default {
  BASE_DATA: 1,
  RISK_ANALYSIS: 2,
  CONTRACT_ANALYSIS: 3,
  STATUS_TALK: 4,
  CONCEPT: 5,
  MAX_SORT_INDEX: 99999,

  THEME_VKB: {
    primary: '#024589',
    secondary: '#d7e5f8',
    accent: '#4e83b9',
    info: '#6d9ac9',
    error: '#FF5252',
    success: '#4CAF50',
    warning: '#FFC107',
    ligher: '#e4ecf8'
  },

  THEME_FSOEL: {
    primary: '#DE2920',
    secondary: '#f7eeee',
    accent: '#666666',
    info: '#666666',
    anchor: '#191919',
    error: '#FF5252',
    success: '#4CAF50',
    warning: '#FFC107',
    ligher: '#FFEBEE'
  },

  THEME_SAV: {
    primary: '#004f9f',
    secondary: '#dbe6f1',
    accent: '#6d9ac9',
    info: '#6d9ac9',
    error: '#FF5252',
    success: '#4CAF50',
    warning: '#FFC107',
    ligher: '#e4ecf8'
  }
}
